import React, { memo } from 'react';
import { Stack, Typography } from 'investira.react.components';
import { displays } from 'investira.react.lib';
import { PessoaImage } from '../../molecules';

const SearchPessoaItem = memo(props => {
  const { data, onClick } = props;

  return (
    <Stack
      id={data.pessoa_id}
      key={data.pessoa_id}
      direction="row"
      spacing={3}
      alignItems="center"
      component="li"
      onClick={onClick}
      sx={{
        px: 2,
        py: 1,
        cursor: 'pointer',
        '&:hover': {
          color: 'gray',
          backgroundColor: 'background.main'
        }
      }}>
      <Stack>
        <PessoaImage
          logoPessoaId={data.logo_pessoa_id}
          alt={data.pessoa}
          hasLogo={data.logo_ok}
          size={36}
        />
      </Stack>
      <Stack>
        <Typography variant="body2" color="textPrimary">
          {data.pessoa_fantasia || data.pessoa}
        </Typography>
        <Stack direction="row" spacing={{ xs: 0, sm: 1 }}>
          <Typography
            variant="caption"
            color="textSecondary"
            sx={{
              display: { xs: 'none', sm: 'inline-block' }
            }}>
            {`${data.pessoa}`}
          </Typography>
          <Typography variant="caption" color="textSecondary">
            {`${displays.cnpj(data.cnpj)}`}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
});

export default SearchPessoaItem;
